<template>
  <div class="EditAddRepresentante">
    <el-form v-loading="loadingPage" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
      <HeaderPage>
        <el-button style="height: 44px; margin-left: 1rem" native-type="submit" @click.prevent="submitForm('ruleForm')">Salvar</el-button>
        <el-dropdown v-if="ruleForm.id" trigger="click" @command="handleAction">
          <el-button type="text" icon="el-icon-more" class="el-dropdown-link"></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="alter_type">Alterar Tipo de Cliente</el-dropdown-item>
            <el-dropdown-item icon="el-icon-delete" command="DELETE">Excluir</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </HeaderPage>

      <el-dialog
          :visible.sync="dialogVisible"
          width="30%">
        <el-form v-loading="loadingPageDialog" :model="ruleFormType" ref="ruleFormType" :rules="rules" @submit.prevent v-on:submit.prevent>
          <el-form-item prop="change_agent_id" label="Representante que será associado aos registros">
            <SelectSearchRepresentante :model="ruleFormType.change_agent_id" :isEdit="false" @handleValue=" (x) => { ruleFormType.change_agent_id = x } " />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Cancelar</el-button>
            <el-button type="primary" @click="submitChangeType">Alterar</el-button>
          </span>
      </el-dialog>

      <el-card shadow="never" :body-style="{ padding: '0px' }" style="background-color: transparent; border: none">
        <el-tabs v-model="activeNameTabs" type="card" style="margin: 20px auto 0 auto;max-width: 1300px;">
          <el-tab-pane label="Geral" name="1">
            <el-row :gutter="20">
              <el-col :lg="12" :sm="12" :xs="24">
                <el-form-item prop="name" label="Nome" :error="error.name">
                  <el-input size="large" v-model="ruleForm.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="birthday" label="Data de nascimento" :error="error.birthday">
                  <el-date-picker style="width: 100%;" format="dd/MM/yyyy" value-format="yyyy-MM-dd" v-model="ruleForm.birthday" type="date" />
                </el-form-item>
              </el-col>
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="gender" label="Género" :error="error.gender">
                  <el-select v-model="ruleForm.gender" clearable style="width: 100%">
                    <el-option label="Masculino" value="male" />
                    <el-option label="Feminino" value="female" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item prop="cpf" label="CPF" :error="error.cpf">
                  <el-input masked="true" size="large" v-model="ruleForm.cpf" v-mask="'###.###.###-##'" required />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item prop="rg" label="RG" :error="error.rg">
                  <el-input masked="true" size="large" v-model="ruleForm.rg" v-mask="'##.###.###-#'" required />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item prop="type_person" label="Tipo de pessoa" :error="error.type_person">
                  <el-select v-model="ruleForm.type_person" clearable style="width: 100%">
                    <el-option label="Empresa" value="business" />
                    <el-option label="Individual" value="individual" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="20" :sm="20" :xs="24">
                <el-form-item prop="marketplace_id" label="Marketplace" :error="error.marketplace_id">
                  <SelectSearchMarketplace :disabled="$can('2')" :model="ruleForm.marketplace_id" :isEdit="false" @handleValue=" (x) => { ruleForm.marketplace_id = x } "  />
                </el-form-item>
              </el-col>
              <el-col :lg="4" :sm="4" :xs="24">
                <div style="margin-top: 25px">
                  <!-- <el-button v-if="isEdit && ruleForm.associate !== 'Y'" @click="() => {dialogVisibleRepre = true}" type="primary" style="width: 100%">Associar</el-button>
                  <el-button v-if="isEdit && ruleForm.associate === 'Y'" @click="desassociar" type="danger" style="width: 100%">Desassociar</el-button> -->
                  <el-dialog title="Associar Marketplace ao Representante" :visible.sync="dialogVisibleRepre" :before-close="(done) => {
                  ruleFormAss = {
                    marketplace_id:  '',
                  }
                  done()
                }">
                    <el-form v-loading="loadingPageplan" v-if="dialogVisibleRepre" :model="ruleFormAss" ref="ruleFormPlan" @submit.prevent v-on:submit.prevent>
                      <el-form-item prop="marketplace_id" label="Marketplace" :error="error.marketplace_id" :rules="[{required: true, message: 'Requerido', trigger: 'blur'}]">
                        <SelectSearchMarketplace :disabled="false" :model="ruleFormAss.marketplace_id" :isEdit="false" @handleValue=" (x) => { ruleFormAss.marketplace_id = x } "  />
                      </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                    <el-button style="float: left" @click="() => {dialogVisibleRepre = false; $refs['ruleFormAss'].resetFields()}">Cancelar</el-button>
                    <el-button type="primary" native-type="submit" @click.prevent="associar('ruleFormPlan')">Associar</el-button>
                  </span>
                  </el-dialog>
                </div>
              </el-col>
            </el-row>
            <el-divider content-position="left">Contato</el-divider>
            <el-row :gutter="20">
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="type_contact" label="Tipo do Contato" :error="error.type_contact">
                  <el-select v-model="ruleForm.type_contact" clearable style="width: 100%">
                    <el-option label="Pessoal" value="personal" />
                    <el-option label="Empresa" value="business" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="phone_operator_id" label="Operadora de telefone" :error="error.phone_operator_id">
                  <SelectSearchPhoneOperator :model="ruleForm.phone_operator_id" :isEdit="isEdit" @handleValue="(x) => {ruleForm.phone_operator_id = x}"  />
                </el-form-item>
              </el-col>

              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="phone" label="Telefone">
                  <el-input masked="true" size="large" v-model="ruleForm.phone" v-mask="['(##) #####-####', '(##) ####-####']" required />
                </el-form-item>
              </el-col>
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="email" label="E-mail">
                  <el-input type="email" size="large" v-model="ruleForm.email" required />
                </el-form-item>
              </el-col>
            </el-row>
            <el-divider content-position="left">Empresa</el-divider>
            <el-row :gutter="20">
              <el-col :lg="16" :sm="16" :xs="24">
                <el-form-item prop="name_store" label="Nome" :error="error.name_store">
                  <el-input size="name_store" v-model="ruleForm.name_store"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item prop="mcc_id" label="Ramo de negócio" :error="error.mcc_id">
                  <SelectSearchMCC :model="ruleForm.mcc_id" :isEdit="isEdit" @handleValue="(x) => {ruleForm.mcc_id = x}"  />
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="this.ruleForm.type_person === 'business'">
              <el-form-item prop="business_name" label="Razão Social da empresa" :error="error.business_name">
                <el-input size="business_name" v-model="ruleForm.business_name"></el-input>
              </el-form-item>
              <el-row :gutter="20">
                <el-col :lg="24" :sm="24" :xs="24">
                  <el-row :gutter="20">
                    <el-col :lg="12" :sm="12" :xs="24">
                      <el-form-item prop="business_cnpj" label="CNPJ" :error="error.business_cnpj">
                        <el-input masked="true" size="large" v-model="ruleForm.business_cnpj" v-mask="'##.###.###/####-##'" required />
                      </el-form-item>
                    </el-col>
                    <el-col :lg="6" :sm="6" :xs="24">
                      <el-form-item prop="business_date" label="Data de abertura da empresa" :error="error.business_date">
                        <el-date-picker style="width: 100%;" format="dd/MM/yyyy" value-format="yyyy-MM-dd" v-model="ruleForm.business_date" type="date" />
                      </el-form-item>
                    </el-col>
                    <el-col :lg="6" :md="6" :xs="24">
                      <el-form-item prop="type_business_id" label="Tipo de negócio" :rules="[{required: true, message: 'Requerido', trigger: 'blur'}]">
                        <SelectSearchTypeBusiness :model="ruleForm.type_business_id" :isEdit="isEdit" @handleValue=" (x) => { ruleForm.type_business_id = x } " />
                      </el-form-item>
                    </el-col>

                  </el-row>

                  <el-form-item prop="business_description" label="Descrição/Observações da empresa" :error="error.business_description">
                    <el-input
                      type="textarea"
                      :rows="2"
                      v-model="ruleForm.business_description">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane :disabled="!isEdit" label="Endereço" name="address">
            <el-row :gutter="20">
              <el-col :lg="12" :md="12">
                <el-form-item prop="postal_code" label="CEP" :error="error.postal_code">
                  <el-input masked="true" size="large" v-mask="['#####-###']" v-model="ruleForm.postal_code" required></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :sm="12" :xs="24">
                <el-form-item prop="type_address" label="Tipo de Endereço" :error="error.type_address">
                  <el-select v-model="ruleForm.type_address" clearable style="width: 100%">
                    <el-option label="Empresa" value="business" />
                    <el-option label="Pessoal" value="personal" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="18" :md="18">
                <el-form-item prop="street" label="Endereço" :error="error.street">
                  <el-input size="large" v-model="ruleForm.street" required>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="6" :md="6">
                <el-form-item prop="number" label="Nº" :error="error.number">
                  <el-input size="large" v-model="ruleForm.number" required>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="complement" label="Complemento" :error="error.complement">
              <el-input size="large" v-model="ruleForm.complement" required>
              </el-input>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :lg="8" :md="8">
                <el-form-item prop="neighborhood" label="Bairro" :error="error.neighborhood">
                  <el-input size="large" v-model="ruleForm.neighborhood" type="text" required/>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="8">
                <el-form-item prop="city_id" label="Cidade" :error="error.city_id">
                  <el-select
                    size="large"
                    v-model="ruleForm.city_id"
                    style="width: 100%;"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Pesquise a Cidade"
                    :remote-method="serchCity"
                    :loading="loadingCity">
                    <el-option v-for="(item, index) in cityOptions" :key="index" :label="item.title" :value="item.id">
                      <span style="float: left">{{ item.title }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">DDD {{ item.iso_ddd }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="8">
                <el-form-item prop="state_id" label="Estado" :error="error.state_id">
                  <el-select
                    size="large"
                    v-model="ruleForm.state_id"
                    style="width: 100%;"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Pesquise o Estado"
                    :remote-method="serchState"
                    :loading="loadingCity">
                    <el-option v-for="(item, index) in StateOptions" :key="index" :label="item.title" :value="item.id">
                      <span style="float: left">{{ item.title }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.letter }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane :disabled="!isEdit" label="Planos" name="plans">
            <PlanosRepresentante />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import SelectSearchTypeBusiness from "@/app/components/TypeBusiness/SelectSearchTypeBusiness";
import SelectSearchPhoneOperator from "@/app/components/PhoneOperator/SelectSearchPhoneOperator";
import SelectSearchMCC from "@/app/components/MCC/SelectSearchMCC";
import {mapGetters} from "vuex";
import {getCity, getState} from "@/app/domains/Config/services";
import {
  deleteRepresentantes,
  getRepresentantes,
  postAssociarMktRepresentante, postChangeTypeMarketplaces, postChangeTypeRepresentantes,
  postDesassociarMktRepresentante,
  postRepresentantes,
  putRepresentantes
} from "@/app/domains/Records/services";
import {
  clearRuleForm,
  getErrorFilds,
  makeErrorFilds,
  setFormData,
  validateCNPJ,
  validateCPF,
  validateEmail
} from "@/app/plugins/utils";
import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
import PlanosRepresentante from "@/app/domains/Records/components/Representantes/PlanosRepresentante";
import SelectSearchRepresentante from "@/app/components/Representante/SelectSearchRepresentante";

export default {
  name: "EditAddRepresentante",
  components: {
    HeaderPage,
    SelectSearchPhoneOperator,
    SelectSearchMCC,
    SelectSearchMarketplace,
    PlanosRepresentante,
    SelectSearchRepresentante,
    SelectSearchTypeBusiness
  },
  computed: {
    ...mapGetters('Auth', ['getToken', 'currentUser']),
    isEdit: function () {
      return !!(this.ruleForm.id)
    }
  },

  data () {
    return {
      ruleFormType: {
        agent_id: this.$route.params.id,
        change_agent_id: '',
      },
      loadingPageDialog: false,
      dialogVisible: false,
      loadingPage: false,
      loadingPageplan: false,
      dialogVisibleRepre: false,
      loadingUpImage: false,
      loadingCity: false,
      urlImage: '',
      activeNameTabs: "1",
      cityOptions: [],
      StateOptions: [],
      ruleFormAss: {
        marketplace_id: ''
      },
      ruleForm: {
        name: '',
        type_person: '',
        cpf: '',
        rg: '',
        birthday: '',
        gender: '',
        type_contact: '',
        marketplace_id: '',
        agent_id: '',
        phone_operator_id: '',
        phone: '',
        email: '',
        business_cnpj: '',
        name_store: '',
        business_name: '',
        business_date: '',
        mcc_id: '',
        business_description: '',
        color_primary: '',
        color_secondary: '',
        street: '',
        country_code: '55',
         type_business_id:2,
      },
      rules: {
        name: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        birthday: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        cpf: [
          {required: true, message: 'Requerido', trigger: 'blur'},
          { validator: this.cpfVerify, trigger: "blur"}
        ],
        email: [
          {required: true, message: 'Requerido', trigger: 'blur'},
          { validator: this.emailVerify, trigger: "blur"}
        ],
        gender: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        mcc_id: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        name_store: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        phone_operator_id: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        type_contact: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        // marketplace_id: [
        //   {required: true, message: 'Requerido', trigger: 'blur'}
        // ],
        // agent_id: [
        //   {required: true, message: 'Requerido', trigger: 'blur'}
        // ],
        type_person: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        business_cnpj: [
          {required: true, message: 'Requerido', trigger: 'blur'},
          { validator: this.cnpjVerify, trigger: "blur"}
        ],
        business_date: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        business_name: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
      },
      error: {},
    }
  },
  methods: {
    submitChangeType() {
      this.$confirm('Deseja alterar o tipo desse Representante para Marketplace?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
        center: true,
        type: 'warning'
      }).then(async () => {
        try {
          await postChangeTypeRepresentantes(this.ruleFormType)
          this.$message({
            showClose: true,
            message: 'Alterado com sucesso',
            type: 'success'
          })
          await this.$router.push({name: 'records.representante.index'})
        } catch (e) {
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {
        this.loadingPage = false
      });
    },
    async handleAction (act) {
      if (act === 'DELETE') {
        this.loadingPage = true
        this.$confirm('Deseja realmente excluir este representante?', 'Atenção', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          center: true,
          type: 'warning'
        }).then(async () => {
          try {
            await deleteRepresentantes(this.ruleForm.id)
            await this.$router.push({name: 'records.representante.index'})
            this.$message({
              showClose: true,
              message: 'Representante foi excluido.',
              type: 'success'
            })
          } catch (e) {
            this.error = {}
            this.error = makeErrorFilds(e)
            this.$message({
              showClose: true,
              message: makeErrorFilds(e).agent_id,
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }).catch(() => {
          this.loadingPage = false
        });
      } else if (act === 'alter_type') {
        this.dialogVisible = true
      }
    },
    async serchCity (query) {
      if (query.length > 2) {
        this.loadingCity = true
        try {
          let response = await getCity('?name='+query)
          this.cityOptions = response.data.data
          this.$set(this.ruleForm, 'country_code', 55)
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.body.error.message,
            type: 'error'
          })
        } finally {
          this.loadingCity = false
        }
      }
    },
    async serchState (query) {
      if (query.length > 2) {
        this.loadingCity = true
        try {
          let response = await getState('?name='+query)
          this.StateOptions = response.data.data
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.body.error.message,
            type: 'error'
          })
        } finally {
          this.loadingCity = false
        }
      }
    },
    cpfVerify (rule, value, callback) {
      if (validateCPF(this.ruleForm.cpf)) {
        callback()
      } else {
        callback(new Error('CPF Invalido'))
      }
    },
    cnpjVerify (rule, value, callback) {
      if (validateCNPJ(this.ruleForm.business_cnpj)) {
        callback()
      } else {
        callback(new Error('CNPJ Invalido'))
      }
    },
    emailVerify (rule, value, callback) {
      if (validateEmail(this.ruleForm.email)) {
        callback()
      } else {
        callback(new Error('Email Invalido'))
      }
    },
    submitForm (ruleForm) {
      this.error = {}
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          this.loadingPage = true
          try {
            if (this.ruleForm.id !== undefined) {
              this.$set(this.ruleForm, 'country_code', 55)
              await putRepresentantes(clearRuleForm(this.ruleForm))
              await this.$router.push({name: 'records.representante.index'})
              this.$message({
                showClose: true,
                message: 'Atualizado com sucesso',
                type: 'success'
              })
            } else {
              await postRepresentantes(setFormData(clearRuleForm(this.ruleForm)))
              this.$message({
                showClose: true,
                message: 'Adicionado com sucesso',
                type: 'success'
              })
              await this.$router.push({name: 'records.representante.index'})
            }
          } catch (e) {
            this.error = makeErrorFilds(e)
            if (this.error.address) {
              this.activeNameTabs = "address"
            }
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }
      })
    },
    desassociar () {
      this.loadingPage = true
      this.$confirm('Deseja realmente desassociar?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
        center: true,
        type: 'warning'
      }).then(async () => {
        try {
          await postDesassociarMktRepresentante(this.ruleForm.id)
          this.$message({
            showClose: true,
            message: 'Desassociação feita com sucesso.',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.data,
            type: 'error'
          })
        } finally {
          await this.initElement()
          this.loadingPage = false
        }
      }).catch(() => {
        this.loadingPage = false
      });
    },
    associar (ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          this.loadingPage = true
          this.loadingPageplan = true
          this.$confirm('Deseja realmente associar?', 'Atenção', {
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
            center: true,
            type: 'warning'
          }).then(async () => {
            try {
              await postAssociarMktRepresentante({id: this.ruleForm.id, data: this.ruleFormAss })
              this.$message({
                showClose: true,
                message: 'Associação feita com sucesso.',
                type: 'success'
              })
              await this.initElement()
              this.dialogVisibleRepre = false
            } catch (e) {
              this.$message({
                showClose: true,
                message: e.data,
                type: 'error'
              })
            } finally {
              this.loadingPage = false
              this.loadingPageplan = false
            }
          }).catch(() => {
            this.loadingPage = false
            this.loadingPageplan = false
          });
        }
      })
    },
    async initElement() {
      try {
        if (this.$route.params.id) {
          this.loadingPage = true
          let response = await getRepresentantes(`/${this.$route.params.id}`)
          

          this.urlImage = response.data.uri_logo
          this.ruleForm = response.data.person
          // this.$set(this.ruleForm, 'color_primary', response.data.color_primary)
          this.$set(this.ruleForm, 'associate', response.data.associate)
          this.$set(this.ruleForm, 'phone', response.data.person.contact.phone)
          this.$set(this.ruleForm, 'phone_operator_id', response.data.person.contact.phone_operator_id)
          this.$set(this.ruleForm, 'type_contact', response.data.person.contact.type_contact)
          this.$set(this.ruleForm, 'email', response.data.person.contact.email)
          this.$set(this.ruleForm, 'id', response.data.id)

          this.$set(this.ruleForm, 'marketplace_id', response.data.marketplace_id)
          this.$set(this.ruleForm, 'person_id', response.data.person_id)
          if (response.data.agent_id) {
            this.$set(this.ruleForm, 'agent_id', response.data.agent_id)
          }

          if(response.data.person.type_person === "business") {
          this.$set(this.ruleForm, 'business_cnpj', response.data.person.business[0].business_cnpj)
          this.$set(this.ruleForm, 'business_date', response.data.person.business[0].business_date)
          this.$set(this.ruleForm, 'business_description', response.data.person.business[0].business_description)
          this.$set(this.ruleForm, 'business_name', response.data.person.business[0].business_name)
          this.$set(this.ruleForm, 'type_business_id', response.data.person.business[0].type_business_id)
          }

          if (response.data.person.address) {
            this.$set(this.ruleForm, 'postal_code', response.data.person.address.postal_code)
            this.$set(this.ruleForm, 'street', response.data.person.address.street)
            this.$set(this.ruleForm, 'number', response.data.person.address.number)
            this.$set(this.ruleForm, 'complement', response.data.person.address.complement)
            this.$set(this.ruleForm, 'neighborhood', response.data.person.address.neighborhood)
            this.cityOptions = [response.data.person.address.city]
            this.$set(this.ruleForm, 'city_id', response.data.person.address.city.id)
            this.StateOptions = [response.data.person.address.state]
            this.$set(this.ruleForm, 'state_id', response.data.person.address.state.id)
            this.$set(this.ruleForm, 'type_address', response.data.person.address.type_address)
          }

          delete this.ruleForm.contact
          delete this.ruleForm.person
          delete this.ruleForm.mcc
          delete this.ruleForm.document
          delete this.ruleForm.bank_account
        } else {
          
          if (this.$can('2')) {
            this.$set(this.ruleForm, 'marketplace_id', this.currentUser.marketplace_id)
          }
        }
      } catch (e) {
        
        this.$message({
          showClose: true,
          message: e.data.data,
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    }
  },
  async mounted() {
    await this.initElement()
  }
}
</script>

<style scoped>

</style>
